<template>
  <v-card>
    <v-toolbar class="teal white--text">
      <v-toolbar-title>{{ $t('profile.common.title') }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon class="white--text" @click="save">
        <v-icon>check</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text style="position: relative">
      <v-alert dismissible transition="fade-transition" success :value="saved" style="position: absolute; left: 0px; top: 0px; width: 100%; z-index: 1">
        {{ $t('profile.common.saved') }}
      </v-alert>

      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              :label="$t('headers.personName')"
              v-model="value.name"
            />
          </v-flex>
          <v-flex xs12>
            <v-text-field
              :label="$t('headers.surname')"
              v-model="value.surname"
            />
          </v-flex>
          <v-flex xs12>
            <v-text-field
              :label="$t('headers.email')"
              v-model="value.email"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import User from '@/models/User'

export default {
  props: ['value'],
  data () {
    return {
      saved: false
    }
  },
  methods: {
    save () {
      User.update(this.value, [ 'username', 'role', 'name', 'surname', 'email' ])
        .then(result => {
          this.$store.auth.user.name = this.value.name
          this.$store.auth.user.surname = this.value.surname
          this.$store.auth.user.email = this.value.email

          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 3000)
        })
        .catch(error => {
          console.error(error)
          alert(this.$t('savingFailed'))
        })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Common.vue?b6175bd0